import { useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';

import { sendFirstTouchThunk } from './sendFirstTouchThunk';

export const useSendFirstTouch = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(sendFirstTouchThunk({ sourceUrl: window.location.href }));
  }, [dispatch]);
};
